import { Injectable } from '@angular/core';
import { WindowReferenceService } from './window-reference.service';

@Injectable({
    providedIn: 'root',
})
export class DataLayerService {
    private window;

    constructor(private _windowRef: WindowReferenceService) {
        this.window = _windowRef.nativeWindow;
    }

    private pingHome(obj: any) {
        if (obj) this.window.dataLayer.push(obj);
    }

    logPageView(url: string) {
        const hit = {
            event: 'virtualPageview',
            pageUrl: url,
            pageTitle: url,
        };
        this.pingHome(hit);
    }

    logEvent(event: string, category: string, action: string, label: string) {
        const hit = {
            event: event,
            category: category,
            action: action,
            label: label,
        };
        this.pingHome(hit);
    }
}
